import { X } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FilePick, ColumnMap } from "@/components/clients/ClientImportParts";
import { ImportPreview } from "@/components/clients/ClientImportPreview";

const T = "welcome-clients";

// First-time setup: pick a client spreadsheet now, it's imported when setup finishes.
export const WelcomeClients = ({ imp, depotNames, depot, setDepot }) => (
  <div className="rounded-lg border border-border p-4 space-y-3 min-w-0" data-testid={T}>
    <div>
      <p className="text-sm font-medium">Your clients <span className="text-muted-foreground font-normal">(optional)</span></p>
      <p className="text-xs text-muted-foreground">Upload your client list from a spreadsheet (CSV or Excel, e.g. from Xero, MYOB or Google Sheets). We match the columns — check them below. Your clients are added when you finish setup.</p>
    </div>
    <FilePick imp={imp} testid={T} />
    {imp.sheet && (
      <>
        {depotNames.length > 1 && (
          <div className="space-y-2">
            <Label>Add them to depot</Label>
            <Select value={depot} onValueChange={setDepot}>
              <SelectTrigger data-testid={`${T}-depot`}><SelectValue /></SelectTrigger>
              <SelectContent>{depotNames.map((n) => <SelectItem key={n} value={n} data-testid={`${T}-depot-${n}`}>{n}</SelectItem>)}</SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">Clients for other depots can be imported later from the Clients tab.</p>
          </div>
        )}
        <ColumnMap imp={imp} testid={T} />
        <ImportPreview imp={imp} testid={T} />
        <button type="button" onClick={imp.reset} className="text-xs font-medium text-destructive hover:underline inline-flex items-center gap-1" data-testid={`${T}-remove`}>
          <X className="w-3.5 h-3.5" /> Don&apos;t import this file
        </button>
      </>
    )}
  </div>
);
